import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { API_URL } from '../../../environment';
import { useBrand } from "../../../contexts/BrandContext";

type PasswordField = "password" | "confirmPassword";

const Register3 = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const { logo_url, nome_curto } = useBrand();

  // Estados para os campos do formulário
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [isCodeVerified, setIsCodeVerified] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [verificationError, setVerificationError] = useState("");



  // Estado para mensagem de erro
  const [error, setError] = useState("");

  // Estados para visibilidade das senhas
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  // Função para validar o email (regex similar ao login)
  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSendCode = async () => {
    setVerificationError("");
    try {
      const response = await fetch(`${API_URL}/enviar_codigo`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await response.json();
      if (response.ok) {
        // Código enviado com sucesso; agora exibe o campo para confirmar
        setCodeSent(true);
      } else {
        setVerificationError(data.error || "Erro ao enviar código.");
      }
    } catch (err) {
      console.error("Erro de conexão:", err);
      setVerificationError("Não foi possível conectar ao servidor.");
    }
  };
  

  const handleSendVerificationCode = async () => {
    setError("");
    if (!validateEmail(email)) {
      setError("Email inválido.");
      return;
    }
    try {
      const response = await fetch(`${API_URL}/enviar_codigo`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (response.ok) {
        setIsCodeSent(true);
      } else {
        setError(data.error || "Erro ao enviar código de verificação.");
      }
    } catch (err) {
      console.error("Erro de conexão:", err);
      setError("Não foi possível conectar ao servidor.");
    }
  };

  const handleVerifyCode = async () => {
    setVerificationError("");
    try {
      const response = await fetch(`${API_URL}/verificar_codigo`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), code: verificationCode.trim() }),
      });
      const data = await response.json();
      if (response.ok && data.message.trim() === "Código válido") {
        setIsEmailVerified(true);
        // Opcional: limpe os campos de código e remova a UI de validação
        setVerificationCode("");
      } else {
        setVerificationError(data.error || "Código de verificação inválido.");
      }
    } catch (err) {
      console.error("Erro de conexão:", err);
      setVerificationError("Não foi possível conectar ao servidor.");
    }
  };
  

  // Função para lidar com o registro
  const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
  
    // Validação do email
    if (!validateEmail(email)) {
      setError("Email inválido.");
      return;
    }
  
    // Validação das senhas
    if (password !== confirmPassword) {
      setError("As senhas não conferem.");
      return;
    }
  
    // Prepara os dados para o cadastro
    const dataToSend = {
      nome,
      email,
      senha: password,
    };
  
    try {
      const response = await fetch(`${API_URL}/cadastrar`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      });
      const data = await response.json();
      if (response.ok) {
        // Cadastro bem-sucedido, redireciona para a página de login
        navigate(routes.login3);
      } else {
        setError(data.error || "Erro ao cadastrar conta.");
      }
    } catch (err) {
      console.error("Erro de conexão:", err);
      setError("Não foi possível conectar ao servidor.");
    }
  };  

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
          <div className="col-md-4 mx-auto vh-100">
            <form className="vh-100" onSubmit={handleRegister}>
              <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                <div className="mx-auto mb-5 text-center">
                  <img
                    src={logo_url}
                    className="img-fluid custom-logo-size-login"
                    alt={nome_curto}
                  />
                </div>
                <div>
                  <div className="text-center mb-3">
                    <h2 className="mb-2">Cadastrar</h2>
                    <p className="mb-0">
                      Por favor, coloque suas informações para realizar o seu cadastro!
                    </p>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Nome do cadastro</label>
                    <div className="input-group">
                      <input
                        type="text"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        className="form-control border-end-0"
                        placeholder="Digite seu nome"
                        required
                      />
                      <span className="input-group-text border-start-0">
                        <i className="ti ti-user" />
                      </span>
                    </div>
                  </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <div className="input-group">
                        <input
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="form-control border-end-0"
                          placeholder="Digite seu email"
                          required
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-mail" />
                        </span>
                      </div>
                    </div>
                  <div className="mb-3">
                    <label className="form-label">Senha</label>
                    <div className="pass-group">
                      <input
                        type={passwordVisibility.password ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="pass-input form-control"
                        placeholder="Digite sua senha"
                        required
                      />
                      <span
                        className={`ti toggle-passwords ${passwordVisibility.password ? "ti-eye" : "ti-eye-off"}`}
                        onClick={() => togglePasswordVisibility("password")}
                      ></span>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Confirmar Senha</label>
                    <div className="pass-group">
                      <input
                        type={passwordVisibility.confirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="pass-input form-control"
                        placeholder="Confirme sua senha"
                        required
                      />
                      <span
                        className={`ti toggle-passwords ${passwordVisibility.confirmPassword ? "ti-eye" : "ti-eye-off"}`}
                        onClick={() => togglePasswordVisibility("confirmPassword")}
                      ></span>
                    </div>
                  </div>
                  {error && <p className="text-danger">{error}</p>}
                    <div className="mb-3">
                      <button type="submit" className="btn btn-primary w-100">
                        Cadastrar
                      </button>
                    </div>
                  <div className="text-center">
                    <h6 className="fw-normal text-dark mb-0">
                      Já possui uma conta?
                      <Link to={all_routes.login3} className="hover-a">
                        {" "}
                        Entrar{" "}
                      </Link>
                    </h6>
                  </div>
                </div>
                <div className="mt-5 pb-4 text-center">
                  <p className="mb-0 text-gray-9">Copyright © 2025</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register3;
